// @flow
import React from 'react'
import { StyledField, StyledInput, Error } from 'src/components/Form'
import type { Field as FieldProps } from 'src/types'
import styled from 'styled-components'
export const FlexBox = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 10px 0 0;
  width: 20%;
`

class renderRawField extends React.PureComponent<FieldProps> {
  actualInput: Object
  myInput: Object
  focusInput() {
    this.actualInput.focus()
  }

  blurInput() {
    this.actualInput.blur()
  }

  render() {
    const {
      input,
      label,
      type,
      options,
      required,
      placeholder,
      autocomplete,
      meta: { touched, error }
    } = this.props
    return (
      <FlexBox>
        <StyledField hasError={touched && error}>
          <StyledInput
            {...input}
            className="input"
            placeholder={placeholder}
            options={options}
            required={required}
            ref={c => (this.myInput = c)}
            innerRef={node => (this.actualInput = node)}
            type={type}
            autoComplete={autocomplete}
          />
          {touched && error && (
            <Error noLeft hideArrow>
              {error === 'Required'
                ? `Oh, you need to type your ${`${label}`.toLowerCase()} here to continue`
                : error}
            </Error>
          )}
        </StyledField>
      </FlexBox>
    )
  }
}

export default renderRawField



// WEBPACK FOOTER //
// ./src/helpers/fieldRenderers/RawField.js